// extracted by mini-css-extract-plugin
module.exports = {"padding_b_10":"Motivering_padding_b_10__o6m3n","margin_b_5":"Motivering_margin_b_5__144EQ","wens_width":"Motivering_wens_width__2U4Bh"};